import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {createRole,getRoleDetails,updateRole} from "../../../../Services/rolesServices"
import { toast } from 'react-toastify';
const CreateRole = ({ isShow,close,reRender,popupType,id,roleName }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [role, setRole] = useState("");
  const [roleError, setRoleError] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  useEffect(() => {  
    if(popupType==="EDIT"){
      setRole(roleName)
    }
    setShow(isShow)
  }, []); 
  

   const roleCreate = async (e) => {  
    if(role.trim()==""){
      setRoleError(true);
      return
    } 
     setIsloading(true)
     createRole({role:role}).then((Response)=>{ 
      setIsloading(false)
       if(Response.status){    
         toast.success(Response.message) 
         reRender()
         handleClose()
       }else{
         toast.error(Response.errorMessage)
       } 
     }) 
   };

   const roleUpdate = async (e) => {  
    if(role.trim()==""){
      setRoleError(true);
      return
    } 
     setIsloading(true)
     updateRole({role:role,id:id}).then((Response)=>{ 
      setIsloading(false)
       if(Response.status){    
         toast.success(Response.message) 
         reRender()
         handleClose()
       }else{
         toast.error(Response.errorMessage)
       } 
     }) 
   };


   
  return ( 
    <Modal show={show} onHide={handleClose}  >
        <Modal.Header closeButton>
        <h5 className="modal-title">{popupType==="CREATE"?"Create":"Update"} Role</h5>
        </Modal.Header>
        <Modal.Body> 
        <form className="row g-3">
              <div className="col-12 px-3">
                <label for="SystemRoleName" className="form-label required">Role name {role}</label>
                <input
                  type="text"
                  className="form-control" 
                  placeholder="Enter Role" 
                  value={role}
                  maxLength="35"
                  onChange={(e)=>{setRoleError(false); setRole(e.target.value)}} 
                />
                <div className="new-game-subject-name formerror systemRoleName-erorr"  style={{ display: roleError ? 'block' : 'none' }}>Please provide role name. {roleError}</div>
              </div>
              
            </form>
        </Modal.Body>
        <Modal.Footer>   
        <button
              type="button"
              className="btn btn-secondary"
              onClick={()=>handleClose()}
            >
              Close
            </button>
            <button  type="button" className="btn btn-primary"
            onClick={popupType==="CREATE"?roleCreate:roleUpdate}> 
              {popupType==="CREATE"?"Save":"Update"}
            </button>         
        </Modal.Footer>
      </Modal>
       
  );
};

export default CreateRole;

 